import { useNavigate, useLocation, Link } from 'react-router-dom';
import { authService } from '../services/auth-service';
import { chatService } from '../services/chat-service';
import type { User } from '../types/auth';
import './AppHeader.css';

interface AppHeaderProps {
  user: User | null;
  title: string;
  subtitle?: string;
  showLogout?: boolean;
}

export function AppHeader({ user, showLogout = true }: AppHeaderProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');

  const handleLogout = async () => {
    try {
      // Zuerst alle offenen Konversationen abbrechen
      await chatService.cancelAllConversations();
    } catch (error) {
      // Trotzdem fortfahren mit Logout, auch wenn Abbrechen fehlschlägt
    }
    
    // Dann normal ausloggen
    authService.logout();
    navigate('/');
  };

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-title">
          <img alt="Botfessor" className="header-logo" src="/logo.png" />
          {user?.role === 'Teacher' && isAdminPage && (
            <nav className="header-admin-nav" aria-label="Admin navigation">
              <Link className={location.pathname === '/admin/modules' ? 'active' : ''} to="/admin/modules">Modules</Link>
              <Link className={location.pathname === '/admin/classes' ? 'active' : ''} to="/admin/classes">Classes</Link>
            </nav>
          )}
        </div>
        {user && (
          <div className="user-info">
            <div className="header-user-details">
              <span>{user.firstName} {user.lastName}</span>
              <span className="separator">|</span>
              {showLogout && (
                <a href="#" onClick={handleLogout} className="logout-link">
                  Log out
                </a>
              )}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
